import { useEffect } from "react";
import { Content, Root } from "@radix-ui/react-collapsible";
import {
  PanelCollapsibleInner,
  PanelContentSizer,
  PanelFooter,
  PanelOuterContainer,
  PanelWrapper,
  Props,
} from "./Panel.Parts";

export const Panel = ({
  children,
  header,
  footer,
  open,
  onOpenChange,
}: Props) => {
  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onOpenChange?.(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onOpenChange]);

  return (
    <Root open={open} onOpenChange={onOpenChange} asChild>
      <PanelOuterContainer>
        <Content asChild>
          <PanelWrapper>
            <PanelCollapsibleInner>
              {header && header}
              <PanelContentSizer>{children}</PanelContentSizer>
              {footer && <PanelFooter>{footer}</PanelFooter>}
            </PanelCollapsibleInner>
          </PanelWrapper>
        </Content>
      </PanelOuterContainer>
    </Root>
  );
};
